import { authSnapshot, fetchAuth } from "./authentication";

export let nsfw = false;

export function setNsfw(value) {
    nsfw = value;
}

async function search(data) {
    try {
        const response = await fetchAuth("https://ctlzr-api.bitgate.workers.dev/artemis/mlruns/_search", {
            method: "POST",
            body: JSON.stringify(data),
            headers: {
                "content-type": "application/json"
            }
        });

        return await response.json();
    } catch (e) {
        console.error(e);

        return null;
    }
}

export async function fetchResults(maxResults, filters = {}) {
    return await jsonGet("https://ctlzr-api.bitgate.workers.dev/api/v1/training/images", { maxResults, nsfw, ...filters });
}

export async function countImagesForModel(model) {
    const query = {
        size: 0,
        query: {
            bool: {
                must: [
                    // { match: { event: "inference" } },
                    { term: { "inference.model.keyword": model } }
                ]
            }
        }
    };

    const response = await search(query);

    return response.hits.total.value;
}
window.countImagesForModel = countImagesForModel;

export async function countImagesPerModel() {
    const query = {
        size: 0,
        aggs: {
            models: {
                terms: {
                    field: "inference.model.keyword",
                    size: 1000
                }
            }
        }
    };

    const response = await search(query);

    return Object.fromEntries(response.aggregations.models.buckets.map(b => [b.key, b.doc_count]));
}

window.countImagesPerModel = countImagesPerModel;

export async function fetchImageHistory(maxResults, filters = {}, queryString = null, paginationOffset = 0) {
    return await jsonGet('https://ctlzr-api.bitgate.workers.dev/api/v1/images/search', { maxResults, queryString, paginationOffset, nsfw, ...filters });
}

export async function fetchModelHistory(maxResults, filters = {}, queryString = null, paginationOffset = 0) {
    return await jsonGet('https://ctlzr-api.bitgate.workers.dev/api/v1/img2model/search', { maxResults, queryString, paginationOffset, ...filters });
}


export async function fetchStatus() {
    return await jsonGet('https://ctlzr-api.bitgate.workers.dev/api/v1/training/status');
}

export async function getLoraPreviews(list) {
    const queryValues = list.map(m => {
        const path = m.path;
        const step = Number(path.substring(path.lastIndexOf('/') + 1).replace('checkpoint-', ''));

        return { output_dir: m.args.output_dir, step };
    });

    const query = {
        size: list.length,
        query: {
            bool: {
                should: queryValues.map(lora => ({
                    bool: {
                        must: [
                            {
                                term: {
                                    "image_results.args.output_dir.keyword": lora.output_dir
                                }
                            },
                            {
                                term: {
                                    "image_results.step": lora.step
                                }
                            }
                        ],
                    }
                })),
            }
        },
        fields: [
            "image_results.images", "image_results.args.output_dir", "run_id", "image_results.step"
        ],
        _source: false
    };

    const response = await search(query);
    const values = response.hits.hits.map(e => e.fields);

    let lookup = {};
    for (const entry of values) {
        const output_dir = entry["image_results.args.output_dir"];
        const images = entry["image_results.images"];
        const run_id = entry["run_id"];
        const step = entry["image_results.step"];

        lookup[output_dir + ":" + step] = {
            output_dir, images, run_id, step
        }
        lookup[output_dir] = {
            output_dir, images, run_id, step
        }
    }

    return lookup;
}


export async function getLoraPreview(timestamp, step) {
    const query = {
        size: 1,
        query: {
            bool: {
                must: [
                    {
                        match: {
                            "event": "image_results",
                            "image_results.args.output_dir": `projects/pixels-randomized-coa2/${timestamp}`,
                            "image_results.step": step + ""
                        }
                    }
                ]
            }
        },
        // sort: [
        //     { "@timestamp": { order: "desc" } }
        // ]
    };


    const response = await search(query);

    const values = response.hits.hits.map(e => e._source);

    return values;
}

async function jsonGet(url, queryParams = {}) {
    const urlObj = new URL(url);

    for (const [k, v] of Object.entries(queryParams || {})) {
        if (v !== undefined) {
            urlObj.searchParams.set(k, `${v}`);
        }
    }

    return await (await fetchAuth(urlObj.toString())).json();
}

async function jsonPut(url, dataObj = {}) {
    return await (await fetchAuth(url, { method: 'PUT', body: JSON.stringify(dataObj), headers: { "content-type": "application/json" } },)).json();
}

async function jsonPost(url, dataObj = {}) {
    return await (await fetchAuth(url, { method: 'POST', body: JSON.stringify(dataObj), headers: { "content-type": "application/json" } },)).json();
}

export async function fetchRunArgs(runId) {
    return await jsonGet("https://ctlzr-api.bitgate.workers.dev/api/v1/training/args", { runId });
}

export async function putRunArgs(runId, args) {
    const response = await jsonPut("https://ctlzr-api.bitgate.workers.dev/artemis/mlruns/_doc/" + runId + ".run_args", { run_args: args });
    return response;
}

export async function findRunArgs(outputFolder, step) {
    const query = {
        size: 1,
        query: {
            bool: {
                must: [
                    { match: { event: "current_status" } },
                    { match: { "current_status.args.output_dir": outputFolder } },
                    { match: { "current_status.step": step } }
                ]
            }
        },
    };

    const response = await search(query);

    const values = response.hits.hits.map(e => e._source);

    return values.length > 0 ? values[0] : null;
}

export async function getWasabiFile(key, asText = true) {
    const r = await fetchAuth("https://ctlzr-api.bitgate.workers.dev/api/v1/wasabi?key=" + key + "&token=" + authSnapshot.token);

    if (asText) {
        return await r.text();
    } else {
        return await r.blob();
    }
}

export function getWasabiFileURL(key) {
    return "https://ctlzr-api.bitgate.workers.dev/api/v1/wasabi?key=" + key + "&token=" + authSnapshot.token;
}


export async function logArgumentModified(runId, oldArgs, newArgs, step) {
    const modifiedKeys = [];

    const all = new Set([...Object.keys(oldArgs), ...Object.keys(newArgs)]);
    for (const key of all) {
        if (!oldArgs.hasOwnProperty(key) || !newArgs.hasOwnProperty(key) || oldArgs[key] !== newArgs[key]) {
            modifiedKeys.push(key);
        }
    }

    const obj = {
        "@timestamp": new Date().toISOString(),
        "run_id": runId,
        "event": "modify_args",
        "modify_args": {
            "old": oldArgs,
            "new": newArgs,
            "modified_keys": modifiedKeys,
            "step": step,
        },
    };

    return await jsonPost("https://ctlzr-api.bitgate.workers.dev/artemis/mlruns/_doc/", obj);
}

export async function getArgumentChanges(runId) {
    const query = {
        size: 1000,
        query: {
            bool: {
                must: [
                    { match: { event: "modify_args" } },
                    { term: { "run_id.keyword": runId } },
                ]
            }
        },
        sort: [{ "@timestamp": { order: "desc" } }]
    };

    const response = await search(query);

    const values = response.hits.hits.map(e => e._source);

    return values.map(change => {
        const {
            "@timestamp": timestamp,
            modify_args: data,
        } = change;

        return {
            timestamp,
            ...data,
        }
    });
}

export async function listModels() {
    const resp = await fetchAuth("https://ctlzr-api.bitgate.workers.dev/api/v1/models");
    const json = await resp.json();

    return json;
}

export async function listVaeModels() {
    const resp = await fetchAuth("https://ctlzr-api.bitgate.workers.dev/api/v1/vae-models");
    const json = await resp.json();

    return json;
}

export async function listRemoteModels() {
    const resp = await fetchAuth("https://ctlzr-api.bitgate.workers.dev/api/v1/list-saved-models");
    const json = await resp.json();

    return json.models;
}

export async function invokeLLM(system, user, temperature = 0.8, image = undefined, model = "anthropic/claude-opus-4.6") {
    const resp = await fetchAuth("https://ctlzr-api.bitgate.workers.dev/api/v1/llm", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ system, user, temperature, image, top_p: 1, model })
    });

    const json = await resp.json();
    return json;
}

export async function getModelCaptions(model, sample = undefined, limit = undefined) {
    const resp = await fetchAuth("https://ctlzr-api.bitgate.workers.dev/api/v1/captions", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ model, sample, limit })
    });

    if (!resp.ok) {
        return null;
    }

    const txt = await resp.text();
    const lines = txt.split('\n');
    return lines.filter(l => l).map(l => l.substring(l.indexOf('=') + 1));
}
window.getModelCaptions = getModelCaptions;

export async function downloadModel(model) {
    return await jsonPost("https://ctlzr-api.bitgate.workers.dev/api/v1/models/install", { model });
}

export async function deleteModel(modelPath) {
    // const body = JSON.stringify({ model: modelPath });
    // await fetchAuth("https://training-api.bitgate.ai/delete-model", { method: "POST", body });
}

export async function queueImageGeneration(args, flux2 = false) {
    const params = flux2 ? "?flux2=true" : "";

    await fetchAuth("https://ctlzr-api.bitgate.workers.dev/api/v1/images/generate" + params, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(args)
    });
}

export async function getQueuedTrainingTasks() {
    return await jsonGet("https://ctlzr-api.bitgate.workers.dev/api/v1/training");
}

export async function getTasksOfType(type) {
    return await (await fetchAuth(`https://ctlzr-api.bitgate.workers.dev/api/v1/jobs/${type}/all`)).json();
}

export async function enqueueTaskOfType(type, taskData) {
    return await (await fetchAuth(`https://ctlzr-api.bitgate.workers.dev/api/v1/jobs/${type}`, {
        method: "PUT",
        body: JSON.stringify(taskData),
        headers: {
            "content-type": "application/json"
        }
    })).json();
}

export async function deleteAllQueuedTrainingTasks() {
    // await fetchAuth("https://ctlzr-api.bitgate.workers.dev/api/v1/jobs/sdxl-training/all", { method: "DELETE" });
}

export function getProxiedDownloadUrl(url, filename) {
    const encoded = encodeURIComponent(url);
    return `https://ctlzr-api.bitgate.workers.dev/cf-proxy?url=${encoded}&download=${filename}`
}

export async function queueTraining(args) {
    return await jsonPut("https://ctlzr-api.bitgate.workers.dev/api/v1/training", args);
}

export async function moveTrainingTopOfQueue(taskId) {
    const queue = await getQueuedTrainingTasks();
    const max = queue.reduce((max, b) => Math.max(max, b.priority ?? 1), 0);

    await setTrainingPriority(taskId, max + 1);
}

export async function setTrainingPriority(taskId, priority) {
    await fetchAuth("https://ctlzr-api.bitgate.workers.dev/api/v1/training/" + taskId + "/priority/" + priority, {
        method: "POST"
    });
}

export async function setInferencePriority(taskId, priority) {
    await fetchAuth("https://ctlzr-api.bitgate.workers.dev/api/v1/images/" + taskId + "/priority/" + priority, {
        method: "POST"
    });
}

export async function deleteInferenceTask(key) {
    return await fetchAuth("https://ctlzr-api.bitgate.workers.dev/api/v1/images/" + key, { method: "DELETE" });
}

export async function restartInferenceServer(flux2 = false) {
    const params = flux2 ? "?flux2=true" : "";

    const r = await fetchAuth("https://ctlzr-api.bitgate.workers.dev/api/v1/images/generate" + params, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify([{ action: "restart" }]),
    });

    const data = await r.json();
    console.log('datata', data);
    await setInferencePriority(data.at(-1).key, 100);
}

export async function truncateInferenceQueue() {
    await fetchAuth("https://ctlzr-api.bitgate.workers.dev/api/v1/images/all", { method: "DELETE" });
}

export async function deleteTrainingTask(taskId) {
    await fetchAuth("https://ctlzr-api.bitgate.workers.dev/api/v1/training/" + taskId, { method: "DELETE" });
}

export async function getEvalTasks() {
    const resp = await fetchAuth("https://ctlzr-api.bitgate.workers.dev/api/v1/evals");
    return await resp.json();
}

export async function getTrainingChart(runId, n = 10000, min = 0) {
    const resp = await fetchAuth(`https://ctlzr-api.bitgate.workers.dev/api/v1/graph/${runId}?n=${n}&min=${min}`);
    return await resp.json();
}